/* changed.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 24 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M7.5,0.5C3.4,0.5,0,3.8,0,8s3.4,7.5,7.5,7.5S15,12.2,15,8S11.7,0.5,7.5,0.5z M8.5,12.9h-2v-2h2V12.9z M8.5,9.9
                h-2V2.5h2V9.9z"/>
            <g>
                <path class="foreground-gl" d="M16,0c-1.3,0-2.6,0.3-3.7,0.9c0.3,0.2,0.7,0.4,1,0.6c0.8-0.3,1.7-0.5,2.7-0.5c3.9,0,7,3.2,7,7.1
                    s-3.2,7.1-7,7.1c-1,0-1.9-0.2-2.7-0.5c-0.3,0.2-0.6,0.4-1,0.6c1.1,0.6,2.3,0.9,3.7,0.9c4.4,0,8-3.6,8-8S20.4,0,16,0z"/>
            </g>
            </svg>
         `
};
